import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { GroupInterface } from 'src/app/interfaces/groups/group.interface';

@Component({
  selector: 'app-marketing-campaign-form',
  templateUrl: './marketing-campaign-form.component.html',
  styleUrls: ['./marketing-campaign-form.component.scss']
})
export class MarketingCampaignFormComponent implements OnChanges {

  @Input() form: FormGroup | undefined;
  @Input() groups: GroupInterface[] | undefined;

  protected errorMessage: string | null = null;

  private valueChangesDisposable: Subscription | undefined;

  constructor() { }

  countSelectedGroups(): number {
    return this.form?.get('groups')?.value.reduce((acc: number, value: boolean) => {
      if (value) {
        acc = acc + 1;
      }
      return acc;
    }, 0) || 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // TODO: this is strange, but component behavior demands something like this
    this.valueChangesDisposable?.unsubscribe();
    if (changes.form && changes.form.currentValue) {
      this.valueChangesDisposable = this.form?.valueChanges.subscribe(_ => {
        if (this.form?.get('name')?.touched && this.form?.get('name')?.invalid) {
          if (this.form?.get('name')?.hasError('required')) {
            this.errorMessage = 'name is required';
          } else {
            this.errorMessage = 'name is invalid';
          }
        }
        else if (this.form?.get('groups')?.touched && this.form?.get('groups')?.invalid) {
          if (this.form?.get('groups')?.hasError('atLeastOne')) {
            this.errorMessage = 'groups needs at least one selected';
          } else {
            this.errorMessage = 'groups is invalid';
          }
        }
        else {
          this.errorMessage = null;
        }
      });
    }
  }
}
